import Model, { executeMutation, GqlError, ID, IsoDateTime } from 'src/models/model'
import PaymentConnectorConfiguration from 'src/models/payment-connector/PaymentConnectorConfiguration'

export const logRequest = async function logRequest (command, logData, error) {
  if (!Model.context.currentRegisterClient?.registerStation?.enabledPaymentConnectorConfiguration?.logging_enabled) {
    return
  }

  const results = await executeMutation(
    'logPaymentConnectorRequest',
    {
      command,
      logData,
      error
    },
    {
      success: true,
      errors: {
        structure: {
          code: true,
          description: true
        }
      }
    }
  )

  return results.errors
}
export default class PaymentConnectorLog extends Model {
  static name = 'PaymentConnectorLog'

  static paginate = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true,
        output: true
      },
      command: {
        type: String,
        default: null,
        output: true
      },
      logData: {
        type: String,
        default: null,
        output: true
      },
      error: {
        type: String,
        default: null,
        output: true
      },
      paymentConnectorConfiguration: {
        type: PaymentConnectorConfiguration,
        default: null,
        output: true
      },
      createdAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      updatedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      }
    }

    this.mutations = {
      logPaymentConnectorRequest: {
        arguments: {
          command: {
            type: String,
            required: true
          },
          logData: {
            type: String,
            required: true
          },
          error: {
            type: String,
            required: false
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      }
    }
  }
}
